import { ManagerOptions, SocketOptions } from "socket.io-client";

export class SocketRules {
    public static readonly MAX_RECONNECT_ATTEMPTS = 5;

    static createSocketConfig(token: string): Partial<ManagerOptions & SocketOptions> {
        return {
            path: '/events',
            transports: ["websocket"],
            auth: {
                token: `Bearer ${token}`,
            },
            withCredentials: false,
            autoConnect: true,
            retries: SocketRules.MAX_RECONNECT_ATTEMPTS,
            reconnectionAttempts: SocketRules.MAX_RECONNECT_ATTEMPTS
        }
    }
}